/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Kn_Auth_FailedInputs */

const cs_property_registry_kn_auth_failed = /** @type {(inputs: Property_Registry_Kn_Auth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení do katastru selhalo. Požádejte správce o kontrolu přístupu ČÚZK.`)
};

const en_property_registry_kn_auth_failed = /** @type {(inputs: Property_Registry_Kn_Auth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre sign-in was rejected. Ask your admin to check ČÚZK access.`)
};

/**
* | output |
* | --- |
* | "Cadastre sign-in was rejected. Ask your admin to check ČÚZK access." |
*
* @param {Property_Registry_Kn_Auth_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_kn_auth_failed = /** @type {((inputs?: Property_Registry_Kn_Auth_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Kn_Auth_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_kn_auth_failed(inputs)
	return cs_property_registry_kn_auth_failed(inputs)
});